import * as React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { RootState } from '../../redux/store';
import userManager from '../../utils/userManager';
import { useBnIdle } from 'use-bn-idle';

type Props = {
    children: any,
    component: any,
    exact: any,
    path: any
}

const startTimerSeconds = 3_300;
const promptDialogueSeconds = 300;


const ProtectedRoute: React.FC<Props> = ({ children, component: Component, ...rest }) => {
    const user = (state: RootState) => state.oidcUser;
    const userData = useSelector(user);

    const [promptIsOpen, setPromptIsOpen] = React.useState<boolean>(false);
    const [activityState, setActivityState] = React.useState<'Idle' | 'Active' | null>(null);
    const [remaining, setRemaining] = React.useState<number>(0);

    const [startTimer, stopTimer] = useBnIdle(() => {
        stopTimer();
        setActivityState('Idle');
        setPromptIsOpen(true);
        setRemaining(promptDialogueSeconds);
    })

    const signOutRedirect = () => {
        setPromptIsOpen(false);
        setActivityState(null);
        userManager.signoutRedirect();
    }

    const activate = () => {
        startTimer(startTimerSeconds);
        setActivityState('Active');
        setPromptIsOpen(false);
        setRemaining(0);
    }

    React.useEffect(() => {
        activate();
    }, [])

    React.useEffect(() => {
        let interval: any = null;

        if (activityState == 'Idle') {
            interval = setInterval(() => {
                setRemaining(remaining => remaining - 1);
            }, 1000);
        } else if (activityState == 'Active' && remaining === 0) {
            clearInterval(interval);
        }

        return () => clearInterval(interval);

    }, [activityState, remaining]);

    React.useEffect(() => {
        if (activityState == 'Idle' && remaining <= 0) {
            signOutRedirect();
        }
    }, [remaining])


    return (userData != null && userData.user != null)
        ? (
            <React.Fragment>
                <Route {...rest} component={Component} />
                <Modal isOpen={promptIsOpen} centered  >
                    <ModalHeader style={{ backgroundColor: "#1F4F87", color: "white" }}>Session Information</ModalHeader>
                    <ModalBody>
                        <br />
                        <p>Your session will expire in {Math.floor(remaining % 3600 / 60).toString()} minutes and
                            {" " + Math.floor(remaining % 60).toString()} seconds. </p>
                        <br />
                        <br />
                    </ModalBody>
                    <ModalFooter>
                        <Button style={{ backgroundColor: "#1F4F87", color: "white" }} onClick={activate}>Keep Working</Button>
                        <Button color="secondary" onClick={signOutRedirect}>Logout</Button>
                    </ModalFooter>
                </Modal>
            </React.Fragment>
        )
        : (<Redirect to={'/Login'} />)
}

export default ProtectedRoute